import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PgSliderComponent } from './pg-slider.component';
import { FormsModule } from '@angular/forms';

import { HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';
import { PgContentBlocksModule } from '../pg-content-blocks/pg-content-blocks.module';
import { GestureConfig } from '../core/events/gestures-config';
import * as Hammer from 'hammerjs';

@NgModule({
  imports: [CommonModule, FormsModule, PgContentBlocksModule],
  declarations: [PgSliderComponent],
  providers: [{ provide: HAMMER_GESTURE_CONFIG, useClass: GestureConfig }],
  exports: [PgSliderComponent, PgContentBlocksModule],
})
export class PgSliderModule {
  constructor() {
    if (!window['Hammer']) {
      window['Hammer'] = Hammer.default;
    }
  }
}
